export const shadows = {
  sm: '0px 1px 4px rgba(0, 0, 0, 0.15)',
  md: '0px 2px 6px rgba(0, 0, 0, 0.3);',
  lg: '0px 3px 8px rgba(0, 0, 0, 0.45);',
  xl: '0px 4px 16px rgba(0, 0, 0, 0.6)'
};
